import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../GroupBarChart/GroupBarChart.css";

const GroupBarChart = () => {
  const options = {
    chart: {
      type: "column",
      backgroundColor: "#fff"
    },
    xAxis: {
      categories: [
        "Company A",
        "Company B",
        "Company C",
        "Company D",
        "Company F",
      ],
      title: {
        text: "Companies",
        align: "low",
        x: 0,
        y: 5,
        style: {
          color: "#999",
          fontSize: "16px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "16px",
        },
      },
      lineWidth: 1.8,
      lineColor: "rgb(167, 167, 167)",
    },
    yAxis: {
      min: 10,
      max: 100,
      title: {
        text: "Performance Metrics",
        align: "high",
        rotation: 90,
        x: -10,
        y: 317,
        style: {
          color: "#999",
          fontSize: "16px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "16px",
        },
      },
      lineWidth: 1.8,
      lineColor: "rgb(167, 167, 167)",
    },
    series: [
      {
        name: "Compliance",
        data: [55, 85, 92, 70],
        color: "#5662be",
      },
      {
        name: "Quality",
        data: [81, 35, 89, 91],
        color: "#7a86df",
      },
      {
        name: "Delivery",
        data: [75, 60, 40, 50],
        color: "#efc58a",
      },
    ],
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      style: {
        color: "#999",
        fontSize: "16px",
      },
      backgroundColor: "white",
      borderColor: "#999",
      borderWidth: 1,
      borderRadius: 0,
      padding: 15,
      shadow: false,
    },
  };

  return (
    <>
      <section className="full-section">
        <div className="full-container">
          <div className="full-groupbar-header">
            <h1>
              Company Performance Overview 
              Compliance, Quality, and Delivery Metrics <sub style={{color: "blue"}}>(Group bar chart)</sub>
            </h1>
          </div>

          <div className="full-groupbar-parent">
            <div className="full-groupbar-container">
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            <div className="full-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#5662be" }}
                      ></i>
                    </td>
                    <td>Compliance</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#7a86df" }}
                      ></i>
                    </td>
                    <td>Quality</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#efc58a" }}
                      ></i>
                    </td>
                    <td>Delivery</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GroupBarChart;
